
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Forms/File.html",
      function () {
        return require("private-next-pages/Forms/File.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Forms/File.html"])
      });
    }
  